"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ForgotPassword;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _ForgotPasswordComponent = _interopRequireDefault(require("../components/ForgotPasswordComponent"));
var _helper = require("../common_features/utility/helper");
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
var _strings = require("../common_features/utility/strings");
var _reactRedux = require("react-redux");
var _index = _interopRequireDefault(require("../common_features/assets/index"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ForgotPassword(props) {
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [email, setEmail] = (0, _react.useState)(null);
  const [isEmailTouched, setIsEmailTouched] = (0, _react.useState)(false);
  const [openErrorModal, setopenErrorModal] = (0, _react.useState)(false);
  const [errorModal, setErrorModal] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  function checkDisabled() {
    return (0, _helper.validateEmail)(email) || false;
  }
  function forgotPassword() {
    setIsLoading(true);
    _awsAmplify.Auth.forgotPassword(email.toLowerCase().trim()).then(data => {
      dispatch((0, _loginReducer.loginUserInfo)({
        email,
        challengeName: _strings.CHALLENGE_NAME.FORGOT_PASSWORD
      }));
      setIsLoading(false);
      navigate("/ForgotPasswordOtp");
    }).catch(err => {
      setIsLoading(false);
      if (err.message === "Username/client id combination not found.") {
        setErrorModal(true);
      } else if (err.message === "Attempt limit exceeded, please try after some time.") {
        setopenErrorModal(true);
      }
    });
  }
  const handleCheckEmailBlur = () => {
    setIsEmailTouched(true);
  };
  const onClickOk = () => {
    navigate(_RoutePath.default.login.path);
  };
  const onClickUserOk = () => {
    setErrorModal(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ForgotPasswordComponent.default, {
    positiveActionUserNotExist: onClickUserOk,
    displayUserNotExistModal: errorModal,
    modalUserNotExistHeaderText: "User does not exists",
    variant: "warning-modal",
    displayModalForgotPassword: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalDetailText: "Attempt limit exceeded, please try again after sometime",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Ok",
    positiveAction: onClickOk,
    pentair: _index.default.pentairLogo.default,
    buttonTitle: "Reset",
    emailPlaceholder: "Enter email",
    forgotPasswordHeaderText: "Forgot Password?",
    forgotPasswordDetailText: "No worries. We\u2019ll send 6-digit verification code to your email to reset your password.",
    headerPentairLogoFP: _index.default.pentairLogo.default,
    welcomeScreenImageFP: _index.default.welcomeScreenImage.default,
    email: email,
    onChageEmail: e => {
      (0, _helper.onChangeHandler)(e, setEmail);
    },
    onClickForgotPassword: forgotPassword,
    isDisabled: checkDisabled(),
    isLoading: isLoading,
    isEmailValid: (0, _helper.validateEmail)(email),
    isEmailTouched: isEmailTouched,
    handleEmailBlurr: handleCheckEmailBlur,
    warningImage: _images.default.warning.default
  }));
}